'use client';

import { MuiButton } from '@/components/button/MuiButton';
import { useState, useEffect } from 'react';

export function MapLinkButton() {
  const [isClient, setIsClient] = useState(false);

  // クライアントサイドでのみレンダリングされるようにする
  useEffect(() => {
    setIsClient(true); // クライアントサイドでレンダリングするフラグを立てる
  }, []);

  if (!isClient) {
    return null; // クライアントサイドでない場合、コンポーネントは描画しない
  }

  return (
    <MuiButton
      variant="text"
      onClick={() => {
        window.scrollTo({
          top: document.getElementById('map-section')?.offsetTop,
          behavior: 'auto',
        });
      }}
    >
      マップ
    </MuiButton>
  );
}
